import { inject, Pipe, PipeTransform } from '@angular/core';
import { SellerSettings } from '@api/src/models/AgentApi/Contract/seller-settings';
import { PriceCalculator, TotalPriceOptions } from '@core/calculator/price.calculator';
import { Product } from '@core/calculator/product';
import { UserState } from '@core/user/user.state';
import { filter, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
    name: 'totalPriceCalculate',
})
export class TotalPriceCalculatePipe implements PipeTransform {
    readonly #userState: UserState = inject(UserState);

    public transform(priceValue: number, product: Product, options?: TotalPriceOptions): Observable<number> {
        return this.#userState.sellerSettings$.pipe(
            filter(Boolean),
            map((sellerSettings: SellerSettings) => {
                return new PriceCalculator(priceValue, product, sellerSettings, options).totalPrice;
            }),
        );
    }
}
